import {
	useExperimentalQuery,
	type FetchPolicy,
} from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery';
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop';

import type {
	SitePersonalizationQuery as SitePersonalizationQueryData,
	SitePersonalizationQueryVariables,
	SitePersonalizationQuery_experimentalSitePersonalization_attributes as SitePersonalizationAttributes,
} from './__types__/SitePersonalizationQuery';

export const useExperimentalSitePersonalizationQuery = ({
	skip,
	onError,
	variables,
	fetchPolicy,
}: {
	skip?: boolean;
	onError?: (error: ApolloErrorInterop) => void;
	variables: SitePersonalizationQueryVariables;
	fetchPolicy?: FetchPolicy;
}) => {
	return useExperimentalQuery<
		SitePersonalizationQueryData,
		SitePersonalizationQueryVariables,
		{ attributes: SitePersonalizationAttributes[] }
	>({
		url: ({ cloudId }) => `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`,
		method: 'GET',
		parseResult: (json) => ({
			experimentalSitePersonalization: json,
		}),
		skip,
		onError,
		variables,
		fetchPolicy,
	});
};
